import Common from './Common';

class Provider extends Common {
  constructor() {
    super('/api/v1/subscriptions');
    this.subscribe = this.subscribe.bind(this);
  }

  subscribe(stripe_card_id = null) {
    return this.save({ stripe_card_id }, '/card');
  }
}

const provider = new Provider();

export const { subscribe } = provider;



// WEBPACK FOOTER //
// ./src/services/providers/subscriptions.js